/**
 * @file 通用图片组件
 */
import { ComponentProps } from 'react';
import { default as NextImage } from 'next/image';
import { appPath, convertS3Url } from '@web3/base-utils';

const loader = ({ src }) => {
  const isLocalImg = src.startsWith('/');
  return isLocalImg ? `${appPath}${src}` : convertS3Url(src);
};

export const Image = (props: ComponentProps<typeof NextImage>) => {
  return <NextImage loader={loader} {...props} />;
};
